import React from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import { Button, Icon, Image, Message, Modal, Table } from 'semantic-ui-react';
import { DyzioModalHeader } from 'dyzio-shared-components/lib/components/dyzio-modal';

const noTopPadding = {
  marginTop: 0,
};

export const getIcon = objectType => {
  if (_.eq(objectType, 'VIDEO')) {
    return 'youtube play';
  }
  return 'image';
};

const ADSModal = ({
  onClose,
  linkAd,
  ads,
  existingAds,
  processedAdId,
  failedToLoadAds,
}) => (
  <Modal open onClose={onClose}>
    <DyzioModalHeader headerText="Link Facebook Ads" onClose={onClose} />
    <Modal.Content style={noTopPadding}>
      {
        failedToLoadAds && (
          <Message negative>Failed to load your Facebook Ads - please contact support for assistance</Message>
        )
      }
      {
        _.isEmpty(_.get(ads, 'ads', [])) && (
          <Message>No Ads to display - please contact support for assistance</Message>
        )
      }
      <Table basic="very" textAlign="center">
        <Table.Body>
          {
            _.map(_.get(ads, 'ads'), ad => {
              console.log(ad);
              const alreadyAdded = !_.isNil(_.find(existingAds, ['id', _.get(ad, 'ad.id')]));
              const inProgress = _.eq(processedAdId, _.get(ad, 'ad.id', ''));
              return (
                <Table.Row>
                  <Table.Cell>
                    <Icon name="instagram" color="pink" />
                    <Icon name={getIcon(_.get(ad, 'ad.creative.object_type'))} color="pink" />
                  </Table.Cell>
                  <Table.Cell>
                    <Image src={_.get(ad, 'ad.creative.thumbnail_url')} />
                  </Table.Cell>
                  <Table.Cell textAlign="left">
                    <h4>campaign: { _.get(ad, 'ad.campaign.name') }</h4>
                    <p>ad: { _.get(ad, 'ad.name') }</p>
                  </Table.Cell>
                  <Table.Cell>
                    { _.get(ad, 'ad.campaign.effective_status') }
                  </Table.Cell>
                  <Table.Cell>
                    <Button
                      fluid
                      color="pink"
                      icon
                      labelPosition="left"
                      onClick={() => linkAd(_.get(ad, 'ad.id'))}
                      disabled={alreadyAdded || inProgress}
                    >
                      <Icon name={alreadyAdded ? 'checkmark' : 'linkify'} />
                      {alreadyAdded ? 'Linked' : 'Link'}
                    </Button>
                  </Table.Cell>
                </Table.Row>
              );
            })
          }
        </Table.Body>
      </Table>
    </Modal.Content>
  </Modal>
);

ADSModal.propTypes = {
  onClose: PropTypes.func.isRequired,
  failedToLoadAds: PropTypes.bool,
  linkAd: PropTypes.func.isRequired,
  ads: PropTypes.array,
  existingAds: PropTypes.array.isRequired,
  processedAdId: PropTypes.any,
};

ADSModal.defaultProps = {
  ads: [],
  processedAdId: null,
  failedToLoadAds: false,
};

export default ADSModal;



/** WEBPACK FOOTER **
 ** ./src/containers/view-asset-page/ads-modal.js
 **/